/* eslint-disable react/no-array-index-key */
import { Breadcrumb } from '@propertypal/shared/src/types/breadcrumbs';
import useNeighbours from '@propertypal/web-app/src/hooks/useNeighbours';
import Link from 'next/link';
import router from 'next/router';
import React, { CSSProperties, FunctionComponent, useEffect, useState } from 'react';
import Chevron from '../icons/Chevron';
import { BackLink, Container, Crumb, Crumbs, NextBackLinks } from './Beadcrumb.style';

interface Props {
  containerStyle?: CSSProperties;
  crumbs?: Breadcrumb[];
  padding?: number;
  disableBack?: boolean;
  suffix?: string;
  arrow?: boolean;
  path?: string;
}

const Breadcrumbs: FunctionComponent<Props> = (props) => {
  const [showBack, setShowBack] = useState(false);
  const { nextLink, prevLink, searchUrl } = useNeighbours(props.path);

  useEffect(() => {
    setShowBack(!props.disableBack && window.history.length > 1);
  }, []);

  return (
    <Container className="hide-print" data-testid="breadcrumbs" $padding={props.padding} style={props.containerStyle}>
      {props.crumbs && (
        <>
          {showBack && (
            <BackLink onClick={() => (searchUrl ? router.push(searchUrl) : router.back())}>
              <Chevron size={10} direction="left" arrow={props.arrow} /> Back{props.suffix ? ` ${props.suffix}` : ''}
            </BackLink>
          )}

          <Crumbs itemScope itemType="http://schema.org/BreadcrumbList">
            <Crumb itemScope itemProp="itemListElement" itemType="http://schema.org/ListItem">
              <Link
                href="/"
                prefetch={false}
                id="breadcrumb_home"
                itemScope
                itemProp="item"
                itemType="http://schema.org/ListItem"
                tabIndex={-1}
              >
                <span itemProp="name">Home</span>
              </Link>

              <Chevron containerStyle={{ marginLeft: 5 }} size={10} />

              <meta itemProp="position" content="1" />
            </Crumb>

            {props.crumbs.map((crumb, index, array) => {
              const isLast = index + 1 === array.length;

              if (isLast) {
                return <Crumb key={crumb.url}>{crumb.label}</Crumb>;
              }

              return (
                <Crumb key={index} itemScope itemProp="itemListElement" itemType="http://schema.org/ListItem">
                  <Link
                    href={crumb.url}
                    id={`breadcrumb_${index + 1}`}
                    itemScope
                    itemProp="item"
                    itemType="http://schema.org/Thing"
                    tabIndex={-1}
                    prefetch={false}
                  >
                    <span itemProp="name">{crumb.label}</span>
                  </Link>

                  <Chevron containerStyle={{ marginLeft: 5 }} size={10} />

                  <meta itemProp="position" content={String(index + 2)} />
                </Crumb>
              );
            })}
          </Crumbs>
        </>
      )}

      {(nextLink || prevLink) && (
        <NextBackLinks>
          {prevLink && <Link href={prevLink}>Prev</Link>}

          {nextLink && prevLink && <span> / </span>}

          {nextLink && <Link href={nextLink}>Next</Link>}
        </NextBackLinks>
      )}
    </Container>
  );
};

export default React.memo(Breadcrumbs);
